var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_3580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20.1216C40 30.1033 32.6767 38.3783 23.1167 39.8799V25.9416H27.765L28.65 20.1749H23.1167V16.4332C23.1167 14.8549 23.89 13.3182 26.3667 13.3182H28.8817V8.40825C28.8817 8.40825 26.5983 8.01825 24.4167 8.01825C19.86 8.01825 16.8833 10.7799 16.8833 15.7782V20.1733H11.8183V25.9399H16.8833V39.8783C7.325 38.3749 0 30.1016 0 20.1216C0 9.07658 8.955 0.121582 20 0.121582C31.045 0.121582 40 9.07492 40 20.1216Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_3580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook 1.1a50659e296b2015962279189af5a076.svg";
export { ForwardRef as ReactComponent };